import { useQuery } from "react-query";
import Select from "react-select"

import { getCompanies } from "../../../../../MyApi/hr/companies";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addLevel.module.css";
import { useTranslation } from "react-i18next";

const AddLevel = ({
  setLevelName, setCompanyId,selectedOption,setSelectedOption, levelName, setDescription , description, setActive,active,setDuration,setSort, sort, duration
  
}) => {
const {data , isLoading} = useQuery("getComapines" , getCompanies)
const {t}=useTranslation()
const DescriptionIcon = icons.description
const LevelIcon = icons.levels
const DurationIcon = icons.duration

const user = JSON.parse(localStorage.getItem("user")) || {}
const role =user.id
  const handleNameChange = (e) => {
    setLevelName(e.target.value);
  };
  const handleSelectedIdChange = (selectedOption) => {
    const companyId =selectedOption ?selectedOption.id :null
    setCompanyId(companyId);
    
    
  }; 
  const handleDescChange =(e)=>{
  setDescription(e.target.value)
  }

  const handelDurationChange=(e)=>{
    const {value} =e.target
    setDuration(value)
  }
  const handelSortChange=(e)=>{
    const {value}=e.target
    setSort(value)
  }

  const handleActiveChange = (e)=>{
    const isChecked = e.target.checked
    if(isChecked){
      setActive(1)
    }else{
      setActive(0)
    }

  }
  if(isLoading){
    return <LoadingSpinner/>
  }
  const comapines =data?.data || []

  return (
    <div className={classes.formCard}>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Level")}</label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="text"
            placeholder={t("Enter Level")}
            onChange={handleNameChange}
            value={levelName}
            className={classes.inputCustom}
          />
              
        </div>
         <div className={classes.formCol}>
          <label htmlFor="">{t("Description")} </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <textarea  
            type="textarea"
            placeholder={t("Enter Description")}
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}
          > </textarea> 
        </div>

        
      {role !=="system_adminstrator" && <>
        {!data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> {t("Company")} </label>
          <Select
            type="text"
            options={comapines}
            getOptionLabel={(e)=>e.name}
            getOptionValue={(e)=>e.id}
            placeholder={"Enter Company"}
            onChange={handleSelectedIdChange}
    
          />
        </div> }
      </>  
      }
           <div className={classes.formCol}> 
           <label htmlFor=""> {t("Duration")}</label>
           <div className={classes.iconInput}>
            <DurationIcon />
          </div>
           <input type="number" onChange={handelDurationChange} className={classes.inputCustom} />
           </div>
           <div className={classes.formCol}> 
           <label htmlFor=""> {t("Sort")}</label>
           <input type="number" onChange={handelSortChange}   className={classes.inputCustom} />
           </div>
   
        
          <div className={classes.formCol}> 
           <label htmlFor="" className={active ? `${classes.active}` : `${classes.disActive}`}> {active===1 ?" نشط":"غير نشط"} </label>
         
          <label class="switch">
           <input type="checkbox" onChange={handleActiveChange} checked={active}/>
             <span class="slider round"></span>
         </label>   
        </div>
   
      
     
      </div>
    </div>
  );
};

export default AddLevel;
